import {
    IC_SET_MESSAGE,
    IC_UNSET_MESSAGE,
    IC_UNSET_ALL_MESSAGES
} from '~/frontend/src/constants';
import {
    SetMessageAction,
    UnsetAllMessagesAction,
    UnsetMessageAction
} from '~/frontend/src/actions/intercom';

import {ToastMessage} from 'primereact/toast';

export type PanelIntercomState = {
    notification? : {
        [ key : string ] : any;
    };
    toast? : {
        [ key : string ] : ToastMessage;
    };
};
export type IntercomState = Partial<{
    [ panelKey : string ] : PanelIntercomState;
}>;
export type IntercomMessageType = keyof PanelIntercomState;

const relevantActions = [
    IC_SET_MESSAGE,
    IC_UNSET_MESSAGE,
    IC_UNSET_ALL_MESSAGES
];

/**
 *
 * @param state
 * @param action
 */
export default function intercomReducer( state : IntercomState = {}, action : SetMessageAction | UnsetMessageAction | UnsetAllMessagesAction ) : IntercomState {
    let changed = false,
        panelIntercomState : PanelIntercomState | undefined,
        messageType : IntercomMessageType,
        messageKey,
        message;

    if ( relevantActions.includes( action.type ) ) {
        const { panelKey } = action;

        panelIntercomState = { ...state[ panelKey ] };

        switch ( action.type ) {
            case IC_SET_MESSAGE:
                ( { messageType, messageKey, message } = action );

                if ( messageKey && messageType && message ) {
                    changed = true;

                    panelIntercomState[ messageType ] = {
                        ...panelIntercomState[ messageType ],
                        [ messageKey ]: message
                    };
                }
                break;

            case IC_UNSET_MESSAGE:
                ( { messageType, messageKey } = action );

                if ( messageType && messageKey && panelIntercomState[ messageType ] ) {
                    changed = true;

                    panelIntercomState[ messageType ] = { ...panelIntercomState[ messageType ] };

                    delete panelIntercomState[ messageType ]![ messageKey ];

                    if ( !Object.keys( panelIntercomState[ messageType ]! ).length ) {
                        delete panelIntercomState[ messageType ];
                    }

                    if ( !Object.keys( panelIntercomState ).length ) {
                        panelIntercomState = undefined;
                    }
                }
                break;

            case IC_UNSET_ALL_MESSAGES:
                changed = true;
                panelIntercomState = undefined;

                break;
        }

        if ( changed ) {
            state = { ...state };

            if ( panelIntercomState !== undefined ) {
                state[ panelKey ] = panelIntercomState;
            }
            else {
                delete state[ panelKey ];
            }
        }
    }

    return state;
}
